import {
  router,
  navigation,
  browser,
  console,
  net,
  _money,
  storage,
  store,
  clip,
  media,
  locationDSL,
  message,
  i18n,
  cache,
  envFn,
  env,
  region,
  envVar,
  device,
  token,
} from '@platform/index'
import { FloatMath, CalculationUtils } from '../common/math'
import { registerApi } from '@platform/registry'

import { _default } from './ctx'

let inited = false

export function registerRouter() {
  // router
  _default.register('router.redirectTo', router.redirectTo)
  _default.register('router.navigateTo', router.navigateTo)
  _default.register('router.navigateBack', router.navigateBack)
  _default.register('router.navigateBackTo', router.navigateBackTo)
  _default.register('router.getAllStack', router.getAllStack)
  _default.register('router.getTopRoute', router.getCurrent)
  _default.register('router.clearAllStack', router.clearAllStack)
  _default.register('router.reload', router.reload)
  _default.register('router.onChange', router.onChange)
  _default.register('router.restart', device.restart)
  _default.register('router.exit', device.exit)
  _default.register('router.hasSubScreen', device.hasSubScreen)
  _default.register('router.getSearch', router.getSearch)

  // web open
  _default.register('router.open', browser.open)
  _default.register('browser.open', browser.open)

  // naviagtion
  _default.register('router.getParams', navigation.getParams)
  _default.register('router.getCurrent', navigation.getCurrent)
  _default.register('router.isSubScreen', navigation.isSubScreen)

  _default.register('navigation.getParams', navigation.getParams)
  _default.register('navigation.getCurrent', navigation.getCurrent)
  _default.register('navigation.isSubScreen', navigation.isSubScreen)
}

export function registerBase() {
  // money
  _default.register('lib.money.of', _money.of)
  _default.register('lib.money.ofMajor', _money.ofMajor)
  _default.register('lib.money.min', _money.min)
  _default.register('lib.money.max', _money.max)
  _default.register('lib.money.isMoney', _money.isMoney)
  _default.register('lib.money.equals', _money.equals)
  _default.register('lib.money.compare', _money.compare)
  _default.register('lib.money.getContext', _money.getContext)
  _default.register('lib.money.setContext', _money.setContext)
  _default.register('lib.money.format', _money.format)
  _default.register('lib.money.toMajor', _money.toMajor)
  _default.register('lib.money.symbol', _money.symbol)
  _default.register('lib.money.currency', _money.currency)
  _default.register('lib.money.locale', _money.locale)
  _default.register('lib.money.add', _money.add)
  _default.register('lib.money.subtract', _money.subtract)
  _default.register('lib.money.multiply', _money.multiply)
  _default.register('lib.money.divide', _money.divide)
  _default.register('lib.money.avg', _money.avg)
  _default.register('lib.money.formatParts', _money.formatParts)
  _default.register('lib.money.around', _money.around)

  // console
  _default.register('console.log', console.log)
  _default.register('console.debug', console.debug)
  _default.register('console.warn', console.warn)
  _default.register('console.error', console.error)
  _default.register('console.info', console.info)

  // net
  _default.register('net.init', net.config)
  _default.register('net.get', net.get)
  _default.register('net.request', net.request)
  _default.register('net.post', net.post)
  _default.register('net.upload', net.upload)
  _default.register('net.down', net.download)
  _default.register('net.download', net.download)
  _default.register('net.delete', net.delete)
  _default.register('net.put', net.put)
  _default.register('serviceCall', net.serviceCall)
  _default.register('net.enableCache', net.enableCache)
  _default.register('net.getNetStatus', net.getNetStatus)
  _default.register('connection.getNetStatus', net.getNetStatus) // 兼容旧方案
  _default.register('conection.getNetStatus', net.getNetStatus) // 兼容旧方案

  // math
  _default.register('ext.math.add', FloatMath.add)
  _default.register('ext.math.subtract', FloatMath.subtract)
  _default.register('ext.math.multiply', FloatMath.multiply)
  _default.register('ext.math.divide', FloatMath.divide)
  _default.register('ext.math.toFixed', CalculationUtils.toFixed)

  // storage
  _default.register('localStorage.get', storage.get)
  _default.register('localStorage.set', storage.set)
  _default.register('localStorage.remove', storage.remove)
  _default.register('localStorage.clear', storage.clear)

  // store
  _default.register('getStore', store.get)
  _default.register('setStore', store.set)

  // clip
  _default.register('clip.get', clip.get)
  _default.register('clip.set', clip.set)
  _default.register('clip.clear', clip.clear)

  // media
  _default.register('media.choose', media.choose)

  // location
  _default.register('location.get', locationDSL.get)

  // message
  /**
   * @time @2025-12-15
   * 废弃 message.register 写法 使用 lib.message.register
   * 新增 lib.message.unregister API
   */
  _default.register('message', message.register)
  _default.register('lib.message.register', message.register)
  _default.register('lib.message.unregister', message.unregister)

  // i18n
  _default.register('i18n.getLangList', i18n.getLangList)
  _default.register('i18n.getCurrentLang', i18n.getCurrentLang)
  _default.register('i18n.setCurrentLang', i18n.setCurrentLang)
  _default.register('i18n.onChange', i18n.onChange)

  // cache
  _default.register('cache.get', cache.get)
  _default.register('cache.set', cache.set)
  _default.register('cache.clear', cache.clear)
  _default.register('cache.remove', cache.remove)

  // env
  _default.register('env.getEnv', envFn.getEnv)
  Object.assign(_default.max.env, env)
  _default.register('region.set', region.set)
  _default.register('region.get', region.get)
  _default.register('envVar.getValue', envVar.getValue)
  _default.register('envVar.getMap', envVar.getMap)

  // token
  _default.register('getToken', token.get)
  _default.register('setToken', token.set)

  /** 711演示示例代码 */
  // _default.register('link.scanner', (fn: (code: string) => void) => link.addListener('scanner', fn))
  // _default.register('link.removeScanner', link.removeLastListener)

  registerApi()
}

export function register() {
  if (!inited) {
    registerRouter()
    registerBase()
    inited = true
  }
}
